import React from 'react'
import ReactSelect from 'react-select'
import { get, isNil } from 'lodash'

import { ErrorMessage } from '@/components/forms/ErrorMessage'
import { FormField } from '@/components/forms/FormField'

import { selectStyles, selectTheme, formatOptionWithDescription } from '../../helpers/selectHelpers'

export const Select = ({
  label,
  isDisabled,
  disabled,
  wide,
  options,
  field: { name, value },
  form: { setFieldValue, setFieldTouched, touched, errors },
  onChange = () => {},
  required,
  description,
  defaultValue,
  touchOnChange,
  innerRef,
  index,
  ...props
}) => {
  const fieldError = get(errors, name)
  const fieldTouched = get(touched, name)
  const hasError = !!fieldError && !!fieldTouched

  // Set initial default value if provided and value is not set
  React.useEffect(() => {
    if (defaultValue && !value) {
      setFieldValue(name, defaultValue.value)
    }
  }, [defaultValue, name, value])

  const handleFieldChange = (option, action) => {
    const fieldValue = option ? option.value : ''

    setFieldValue(name, fieldValue)
    if (touchOnChange) {
      setFieldTouched(name, true, false)
    }
    if (onChange) {
      onChange(option, action)
    }
  }

  const handleBlur = () => {
    if (touchOnChange) {
      setFieldTouched(name, true)
    }
  }

  const enableFocus = innerRef && !isNil(index)

  // eslint-disable-next-line no-return-assign
  const handleSetRef = (el) => (innerRef.current[index] = el)

  return (
    <FormField required={required} className={props.className} data-testid={`${name}-select`}>
      {label && <label htmlFor={name}>{label}</label>}
      {description && <div className="form-caption">{description}</div>}
      <ReactSelect
        ref={enableFocus ? handleSetRef : null}
        isClearable
        isSearchable
        closeMenuOnSelect
        escapeClearsValue={false}
        hideSelectedOptions={false}
        backspaceRemovesValue={false}
        options={options}
        value={options.find((option) => option.value === value) || defaultValue || ''}
        onChange={handleFieldChange}
        onBlur={handleBlur}
        isDisabled={isDisabled || disabled}
        selection
        clearable
        formatOptionLabel={formatOptionWithDescription}
        styles={selectStyles(wide, hasError)}
        theme={(theme) => selectTheme(theme)}
        {...props}
        inputId={name}
      />
      {hasError && <ErrorMessage content={fieldError} />}
    </FormField>
  )
}
